import React from 'react';
import GuestHeader from "./GuestHeader";
import GuestFooter from "./GuestFooter";
import { Button } from 'primereact/button';
import { getPaymentHash } from './GuestApiServices';



const QRCodeDisplayWithLayout = () => {



    const onPaymentHash = () => {

        getPaymentHash().then((response) => {
            window.location.href = response.data.data;
        })

    }

    return (
        <>
            <GuestHeader />

            <div
                className="content"
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minHeight: 'calc(100vh - (header_height + footer_height))', // Adjust min-height to fill space between header and footer
                    padding: '20px 20px', // Add some padding
                    textAlign: 'center'
                }}
            >
                <h2>Scan to Pay</h2>
                <p>Use your camera to scan the QR code below.</p>
                <img
                    src="https://api.morbaseliosjsocderby.org/uploads/pay_qr_no.jpeg"
                    alt="QR Code for Church Website or Contact Details"
                    style={{
                        maxWidth: '300px', // Max size for the QR code
                        width: '80%',      // Make it responsive
                        height: 'auto',
                        margin: '20px 0',
                        border: '1px solid #ddd',
                        paddingRight: '10px',
                        paddingLeft: '10px',
                        borderRadius: '8px',
                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
                    }}
                />

                <Button label="Pay Now" severity='danger' icon="pi pi-credit-card" className="mr-2" onClick={() => { onPaymentHash() }} />

                <p className="text-muted mt-5">Thanks for donations</p>
            </div>

            <GuestFooter />
        </>
    );
}

export default QRCodeDisplayWithLayout;